import { MicaraaShopSystemStrategy } from "./implementations/MicaraaShopSystemStrategy";
import { MybacsShopSystemStrategy } from "./implementations/MybacsShopSystemStrategy";
import { OoniqueShopSystemStrategy } from "./implementations/OoniqueShopSystemStrategy";
import { ShopifyShopSystemStrategy } from "./implementations/ShopifyShopSystemStrategy";
import { ShopifyTestShopSystemStrategy } from "./implementations/ShopifyTestShopSystemStrategy";
import { ThisPlaceShopSystemStrategy } from "./implementations/ThisPlaceShopSystemStrategy";
import { WordpressShopSystemStrategy } from "./implementations/WordpressShopSystemStrategy";
import type {
  ShopConfig,
  AppEntry,
} from "../../../../pina-server/node_modules/@prisma/client";
import { RookieBabyShopSystemStrategy } from "./implementations/RookieBabyShopSystemStrategy";

export type FootprintResponse = {
  orderValueWithoutOffset: number | null;
  price: number | null;
  totalFootprint: number | null;
  inCart: boolean;
};

export type SitePayload = {
  ajaxUrl: string | undefined;
  page: string;
  shopSystem: string;
  nonce: string | undefined;
  orderConfirmation?: string;
};

type Constructor<T> = {
  new (...args: any[]): T;
  readonly prototype: T;
};

const _implementations: Record<string, Constructor<IShopSystemStrategy>> = {
  mybacs: MybacsShopSystemStrategy,
  oonique: OoniqueShopSystemStrategy,
  wordpress: WordpressShopSystemStrategy,
  shopify: ShopifyShopSystemStrategy,
  micaraa: MicaraaShopSystemStrategy,
  thisplace: ThisPlaceShopSystemStrategy,
  shopifytest: ShopifyTestShopSystemStrategy,
  rookiebaby: RookieBabyShopSystemStrategy,
};

export function ShopSystemStrategyFactory(
  shopSystem: string,
): IShopSystemStrategy {
  if (!_implementations[shopSystem]) {
    throw new Error(`Shop system ${shopSystem} not supported`);
  }
  return new _implementations[shopSystem]();
}

export interface IShopSystemStrategy {
  //
  loadingDone(): Promise<void>;

  // React to events by the shop system (such as `cart changed`)
  registerEventHandlers(): void;

  // Get app config
  getConfig(
    page: string,
  ): Promise<(ShopConfig & { appEntries: AppEntry[] }) | null>;

  // Receive Footprint of cart
  getFootprint(): Promise<FootprintResponse | undefined>;

  // Toggle the offset item in the cart
  toggleOffset(state: boolean): Promise<boolean>;

  // Refresh Cart Fragment
  refreshCart(): Promise<void>;
}
